module.exports = __webpack_public_path__ + "media/assets/images/category/GoodLuck@2x-abd6d9b8ede87b7f8f60cc600ca7095c.png";